import { render, staticRenderFns } from "./sheng_ri_jiu.vue?vue&type=template&id=2d4f4594&scoped=true&"
import script from "./sheng_ri_jiu.vue?vue&type=script&lang=js&"
export * from "./sheng_ri_jiu.vue?vue&type=script&lang=js&"
import style0 from "./sheng_ri_jiu.vue?vue&type=style&index=0&id=2d4f4594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f4594",
  null
  
)

export default component.exports